import { render, staticRenderFns } from "./Metro.vue?vue&type=template&id=63496bdc"
import script from "./Metro.vue?vue&type=script&lang=js"
export * from "./Metro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports